import { FlexRow } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";

import { ItemTitle, ItemValue, TooltipItem } from "app/components/RankingAxis/Tooltip/styles";
import type { Axis } from "app/components/RankingAxis/types";
import { FORMATTERS } from "app/common/benchmark/formatters";
import { changeIndicatorComponent } from "../../components/TableCells/tableCells";

type TooltipContentSchema = {
    data: Axis;
    format: string;
    tooltipValueTitle: string;
    prefix?: string;
    decimal?: number;
};

const TooltipContent = ({ data, format, tooltipValueTitle, prefix = "", decimal = 0 }: TooltipContentSchema) => {
    const { rankChange: change, absoluteValue, name } = data;
    return (
        <FlexRow>
            <TooltipItem>
                <ItemTitle>Domain</ItemTitle>
                <ItemValue>{name}</ItemValue>
            </TooltipItem>
            <TooltipItem>
                <ItemTitle>{tooltipValueTitle}</ItemTitle>
                <ItemValue>{`${prefix}${FORMATTERS[format](absoluteValue, decimal)}`}</ItemValue>
            </TooltipItem>
            <TooltipItem>
                <ItemTitle>{translate("website.analysis.search.overview.ppc.spend.tooltip.change")}</ItemTitle>
                {changeIndicatorComponent(change, undefined, "right")}
            </TooltipItem>
        </FlexRow>
    );
};

export default TooltipContent;
